import {
  URLPRIFIX,
  GetRecords,
  GetDateTimeFormat,
  RupeeFormatWithoutDecimal,
  formatDate,
} from "../../functions/api";
import React, { useEffect, useState } from "react";
import { useStore } from "../../Components/StateProvider";
import { FaEye } from "react-icons/fa";
import CompanyList from "../../Components/Elements/CompanyList";
import DateRangePicker from "../../Components/Elements/DateRangePicker";
import ProfitLossChart from "../../Components/Elements/ProfitLossChart";
import CustomPieChart from "../../Components/Elements/CustomPieChart";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import dayjs from "dayjs";

const CompanyDashboard = () => {
  const store = useStore();
  const [companyId, setCompanyId] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    total_revenue: 0,
    total_expense: 0,
    net_profit: 0,
    invoiceData: [],
    upcomingDueDates: [],
    upcomingoverdue: [],
    coreManagement: [],
  });

  const handlePeriodChange = (period) => {
    const today = dayjs();
    if (period === "Monthly") {
      setStartDate(today.startOf("month").format("YYYY-MM-DD"));
      setEndDate(today.endOf("month").format("YYYY-MM-DD"));
    } else if (period === "Yearly") {
      setStartDate(today.startOf("year").format("YYYY-MM-DD"));
      setEndDate(today.endOf("year").format("YYYY-MM-DD"));
    }
  };
  // Assuming this is your current RupeeFormat function
  const rupeeformatdecimal = (amount) => {
    return amount.toFixed(0).replace(/(\d)(?=(\d\d)+\d$)/g, "1,");
  };
  useEffect(() => {
    const url = `/api/v2/accounting/getdashboarddata/${
      companyId || 0
    }?startDate=${
      startDate
        ? GetDateTimeFormat(new Date(startDate)).DBFormat + "Z"
        : "1900-01-01T00:00:00Z"
    }&endDate=${
      endDate
        ? GetDateTimeFormat(new Date(endDate)).DBFormat.substring(0, 10) +
          "T23:59:59Z"
        : GetDateTimeFormat().DBFormat.substring(0, 10) + "T23:59:59Z"
    }`;
    console.log(" company id url", url);
    GetRecords(url).then((res) => {
      console.log(" company id res", res);
      if (res.success) {
        setDashboardData(res.record);
      } else {
        console.error("Failed to fetch dashboard data");
      }
    });
  }, [companyId, startDate, endDate]);
  useEffect(() => {
    store.setmodule("companydashboard").then((res) => {
      store.stopLoading();
      store.setheader("Accounting Dashboard");
    });
  }, []);
  return (
    <div className="h-screen  p-3 flex flex-col gap-5">
      <div className="flex justify-between items-center gap-3">
        <div className="flex gap-3">
          <CompanyList onCompanySelect={setCompanyId} />
          <DateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <div className="flex gap-3">
          {store?.state?.properties?.companies?.add && (
            <button
              className="h-[32px] max-sm:h-fit max-sm:p-2 w-[220px] border rounded-lg text-base border-[#000048] hover:bg-tertiary hover:text-primary transition-colors duration-500 shadow-md flex items-center justify-center"
              onClick={() => {
                store.navTo(`/${URLPRIFIX}/companies/create`);
              }}
            >
              Add New Organization{" "}
              <span className="text-2xl font-bold ml-1">+</span>
            </button>
          )}
          {store?.state?.properties?.companies?.view && (
            <button
              className="h-[32px] max-sm:h-fit max-sm:p-2 w-[220px] border rounded-lg text-base border-[#000048] hover:bg-tertiary hover:text-primary transition-colors duration-500 shadow-md flex items-center justify-center"
              onClick={() => {
                store.navTo(`/${URLPRIFIX}/accounts`);
              }}
            >
              View Organizations <FaEye className="text-xl ml-1" />
            </button>
          )}
        </div>
      </div>
      {/* top 4 cards */}
      <div className="grid grid-cols-4 gap-5">
        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/bar-chart.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Total Revenue
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.total_revenue)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>

        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/expense.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Total Expense
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.total_expense)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/profit.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Net Profit/Loss
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.net_profit)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/cashflow.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">Balance</h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.total_revenue)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
      </div>

      {/* 2 Charts */}
      <div className="grid grid-cols-7 gap-5">
        <div className="bg-white border border-[#C0C0C0] shadow-2xl rounded-lg p-4 h-80 col-span-4 ">
          <ProfitLossChart
            total_revenue={dashboardData?.total_revenue}
            total_expense={dashboardData?.total_expense}
            net_profit={dashboardData?.net_profit}
            onPeriodChange={handlePeriodChange}
          />
        </div>
        <div className="bg-white border border-[#C0C0C0] shadow-2xl rounded-lg p-4 h-80 col-span-3 ">
          <CustomPieChart
            coreManagement={dashboardData.coreManagement}
            onPeriodChange={handlePeriodChange}
          />
        </div>
      </div>

      {/* Bottom 3 Sections - Adjusted Heights */}
      <div className="grid grid-cols-[3fr_2.5fr_2.5fr] gap-5">
        {/* Invoice Management */}
        <div className=" bg-white border border-gray-300 shadow-2xl rounded-lg p-4 h-80">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">
            Invoice Management
          </h2>
          <div className="flex items-center justify-between">
            <ResponsiveContainer width={250} height={250}>
              <PieChart>
                <Pie
                  data={dashboardData.invoiceData.map((item) => ({
                    ...item,
                    value: Number(item.value) || 0, // Ensure value is a number
                  }))}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={30}
                  outerRadius={65}
                  paddingAngle={1}
                  label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                >
                  {dashboardData.invoiceData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            {/* Side Indicators */}
            <div className="flex flex-col gap-3">
              {dashboardData?.invoiceData?.map((entry, index) => (
                <div key={index} className="flex items-center gap-2">
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{ backgroundColor: entry.color }}
                  ></div>
                  <span className="text-sm font-medium">{entry.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className=" bg-white border border-gray-300 shadow-2xl rounded-lg p-4 h-80 overflow-y-auto">
          <h2 className="text-xl font-bold">Upcoming Invoice Due's</h2>
          &nbsp;
          {dashboardData?.upcomingDueDates?.map((item, index) => (
            <div key={index} className="mb-3">
              <p className="text-sm text-gray-600">{item.invoice_no}</p>
              <p className="font-semibold">{item.customer_name}</p>
              <p className="text-xs text-gray-500">
                Due Date: {formatDate(item.due_date)}
              </p>
            </div>
          ))}
        </div>
        <div className=" bg-white border border-gray-300 shadow-md rounded-lg p-4 h-80 overflow-y-auto">
          <h2 className="text-xl font-bold">Overdue Payments</h2>

          {dashboardData?.upcomingoverdue?.map((item, index) => (
            <div key={index} className="mb-3">
              <p className="text-sm text-gray-600">{item.invoice_no}</p>
              <p className="font-semibold">{item.customer_name}</p>
              <p className="text-xs text-gray-500">
                Due Date: {formatDate(item.due_date)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboard;
